import { lazy, useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';

import { AppContext } from 'context';
import RequireAuth from '../require-auth';

const Auth = lazy(() => import('modules/auth'));
const Home = lazy(() => import('modules/home'));
const Dashboard = lazy(() => import('modules/dashboard'));
const Contacts = lazy(() => import('modules/contacts'));
const Templates = lazy(() => import('modules/templates'));
const Campaigns = lazy(() => import('modules/campaigns'));
const Unsubscribe = lazy(() => import('modules/unsubscribe'));

const AppRouter = () => {
  const {
    state: { token },
  } = useContext(AppContext);
  return (
    <Routes>
      <Route
        path="/"
        key="home"
        element={
          token && token !== '' ? <Navigate replace to="/contacts" /> : <Home />
        }
      />
      <Route path="/auth/:type" key="auth" element={<Auth />} />
      <Route path="/unsubscribe/:token" key="auth" element={<Unsubscribe />} />
      <Route
        path="/dashboard"
        key="dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/contacts"
        key="contacts"
        element={
          <RequireAuth>
            <Contacts />
          </RequireAuth>
        }
      />
      <Route
        path="/templates/*"
        key="templates"
        element={
          <RequireAuth>
            <Templates />
          </RequireAuth>
        }
      />
      <Route
        path="/campaigns/*"
        key="templates"
        element={
          <RequireAuth>
            <Campaigns />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate replace to="/contacts" />} />
    </Routes>
  );
};

export default AppRouter;
